import { useEffect, useState } from 'react';

/**
 * custom hook to get media queries, for details
 * https://www.netlify.com/blog/2020/12/05/building-a-custom-react-media-query-hook-for-more-responsive-apps/
 * https://dev.to/justincy/4-patterns-for-responsive-props-in-react-39ak
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(true);
  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    setMatches(mediaQuery.matches);

    const handler = () => setMatches(mediaQuery.matches);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler);
      // not supported on ie, so we ignore it here
    } else {
      mediaQuery.addListener(handler);
    }
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handler);
      } else {
        mediaQuery.removeListener(handler);
      }
    };
  }, [matches, query]);
  return matches;
};
